import { type FC } from 'react';
import { IOrderHistory } from '../../../../../types/suscription/history.types';
import { ORDER_STATUS } from '../../../../../types/orders';
import { OrderHistoryStepper } from './components/OrderHistoryStepper';

import './Tab5History.scss';

interface ITab5HistoryProps {
  orderHistory: IOrderHistory[];
  orderStatusName: ORDER_STATUS;
}

const Tab5History: FC<ITab5HistoryProps> = ({ orderHistory, orderStatusName }) => {
  const renderSteps = () => {
    if (!orderHistory?.length) {
      return <p className="emptyStateText">No hay historial disponible para esta orden</p>;
    }

    return <OrderHistoryStepper orderHistory={orderHistory} orderStatusName={orderStatusName} />;
  };

  return (
    <div className="tab5History">
      <h2 className="title">Historial de la orden</h2>
      <div className="boxDetails">{renderSteps()}</div>
    </div>
  );
};

export default Tab5History;
